import { cn } from "@/flokit/utils/styling/cn";
import React, { HTMLProps } from "react";

export const TextSlot = () => (props: { children: string }) => (
  <>{props.children}</>
);

export const DIVSlot =
  (args?: { className?: string }) =>
  ({ children, ...props }: HTMLProps<HTMLDivElement>) => (
    <div {...props} className={cn(args?.className, props.className)}>
      {children}
    </div>
  );

const FormSlot =
  () =>
  ({ children, ...props }: HTMLProps<HTMLFormElement>) => (
    <form {...props}>{children}</form>
  );

export const SpanSlot =
  (args?: { className?: string }) =>
  ({ children, ...props }: HTMLProps<HTMLSpanElement>) => (
    <span {...props} className={cn(args?.className, props.className)}>
      {children}
    </span>
  );

const SectionSlot =
  () =>
  ({
    children,
    ...props
  }: HTMLProps<HTMLDivElement> & {
    role: string;
  }) => <section {...props}>{children}</section>;

export const Slot = () => (props: { children: React.ReactNode }) => (
  <>{props.children}</>
);

const ListItemSlot = () => (props: HTMLProps<HTMLLIElement>) => (
  <li {...props} />
);

const ULSlot = () => (props: HTMLProps<HTMLUListElement>) => (
  <ul {...props} />
);
